export default {
    disclaimer: {
        label_default: "Ik erken en ga ermee akkoord dat de artikelen die ik bestel/ontvang eigendom zijn van O-I en dat deze gebruikt zullen worden voor werkgerelateerde activiteiten van O-I. Als zodanig behoudt O-I zich het recht voor om de teruggave van de artikelen te eisen bij mijn vertrek bij O-I (of eerder, indien vereist door O-I).",
        label_type_1: "Ik bevestig dat de zelfevaluatie voor thuiswerken naar behoren en te goeder trouw is ingevuld, en dat alle apparatuur of meubels die door O-I ter beschikking worden gesteld of via Gear worden besteld, door mij zullen worden gebruikt voor mijn werkzaamheden voor O-I. Ik erken en ga ermee akkoord dat de artikelen die ik bestel/ontvang eigendom zijn van O-I en zullen worden gebruikt voor werkgerelateerde activiteiten voor O-I. Als zodanig behoudt O-I zich het recht voor om de teruggave van de eigendommen te verzoeken bij mijn vertrek bij O-I (of eerder, indien vereist door O-I).",
        errors: {
            required: "Ga akkoord met de gebruiksvoorwaarden"
        }
    },
    cost_center: {
        label: "Kostenplaatscode",
        placeholder: "Kostenplaatscode",
        cost_center_not_found: "Het kan tot 24 uur duren voordat kostenplaatsen die niet worden weergegeven, verschijnen. Neem contact op met de Global Service Desk als u de juiste kostenplaats niet ziet.",
        errors: {
            regex: "Ongeldige kostenplaatscode"
        }
    },
    company_code: {
        label: "Bedrijfscode"
    },
    cost_center_name: {
        label: "Kostenplaatsnaam"
    },
    order_note: {
        label: "Bestelnota",
        placeholder: "Optionele notitie voor de manager ter goedkeuring",
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Houd me op de hoogte van updates over deze bestelling"
    },
    "dell_banner":{
        label: "Vanwege systeemupgrades bij Dell kunnen Dell-bestellingen die tussen 1 en 14 augustus 2026 worden geplaatst, aanzienlijke vertraging oplopen in de verwerking. Houd rekening met langere levertijden gedurende deze periode. Bedankt voor uw begrip."
    }
}